import {
  ListEventTimeSlotsRequest,
  ListEventTimeSlotsResponse,
} from '@wix/ambassador-bookings-availability-v2-time-slot/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { listEventTimeSlots as listEventTimeSlotsHttpRequest } from '@wix/ambassador-bookings-availability-v2-time-slot/http';
import {
  panoramaQueryAvailabilityInteractionStart,
  panoramaQueryAvailabilityInteractionEnd,
} from '../../utils/panorama/panorama';
import { PanoramaTransactions } from '../../utils/panorama/consts';

export const listEventTimeSlots = async (
  listEventTimeSlotsRequest: ListEventTimeSlotsRequest,
  flowAPI: ControllerFlowAPI,
): Promise<ListEventTimeSlotsResponse> => {
  await panoramaQueryAvailabilityInteractionStart({
    flowAPI,
    request: listEventTimeSlotsRequest,
    transaction: PanoramaTransactions.availabilityTimeSlotsClass,
  });

  try {
    const response = (
      await flowAPI.httpClient.request(
        listEventTimeSlotsHttpRequest(listEventTimeSlotsRequest),
      )
    ).data;

    await panoramaQueryAvailabilityInteractionEnd({
      flowAPI,
      response,
      transaction: PanoramaTransactions.availabilityTimeSlotsClass,
      request: listEventTimeSlotsRequest,
    });

    return response;
  } catch (e) {
    throw e;
  }
};